

(function () {
  function kyivHoursMinutes() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Kyiv',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const hour = Number(parts.find((part) => part.type === 'hour').value);
    const minute = Number(parts.find((part) => part.type === 'minute').value);
    return hour * 60 + minute;
  }

  function parseCutoff(value) {
    const match = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
  }

  function update(element) {
    const cutoffMinutes = parseCutoff(element.dataset.cutoff);
    if (cutoffMinutes === null) return;
    const isPastCutoff = kyivHoursMinutes() >= cutoffMinutes;
    if (isPastCutoff) element.textContent = element.dataset.after;
  }

  document.querySelectorAll('[data-gm-delivery-promise]').forEach(update);
})();
